import { useCallback } from 'react';
import { gameStore } from '../store/gameStore';
import { gameLiveConnection } from '../gameLiveConnection/gameLiveConnection';
import { soundService } from '../services/SoundService';
import { getRandomField } from '../../helpers/getRandomField';
import { resultStore } from '../store/resultStore';
import { betStatus } from '../../enums/BetStatus';
import { KeyCode } from '../../enums/KeyCode';
import { gameService } from '../gameLiveConnection/gameService';
import { debounce, usePopupStore } from '@pascal/pascal-core';

export const useGamePad = () => {

  const {
    setAmountByIndex,
    setMatrixType,
    matrixType,
    setChosenField,
    chosenField,
    resultReportState,
    doSpinState,
    setIsGamePadDisabled,
    isGamePadDisabled,
  } = gameStore;

  const { connectionError, reconnect } = usePopupStore();

  const { betResult, cashOutResult } = resultStore;

  const handleBetAmount = debounce(useCallback((index) => {
    if (resultReportState || doSpinState) return;

    soundService.click();
    setAmountByIndex(index);
  }, [resultReportState, doSpinState]), 200, {isImmediate: false});


  const handleMatrixChange = debounce(useCallback((index) => {
    if (resultReportState || doSpinState) return;

    soundService.click();
    setMatrixType(index);

  }, [resultReportState, doSpinState]), 100)


  const handleFieldClick = debounce(useCallback((columnIndex, rowIndex) => {
    if ((!doSpinState && !resultReportState) || betResult.step !== rowIndex || betResult.status === betStatus.lose) return;

    soundService.click();
    setChosenField(columnIndex);
    gameLiveConnection.sendResultReport();

  }, [resultReportState, doSpinState, betResult]), 150, { isImmediate: true });


  const handleCashOutButton = useCallback(() => {
    if (!resultReportState || isGamePadDisabled) return;
    soundService.click();
    setIsGamePadDisabled(true);
    gameLiveConnection.sendCashOut();
  }, [resultReportState, isGamePadDisabled]);


  const handleSpaceSpin = useCallback((event) => {
      if (event.code !== KeyCode.Space) return;

      if (cashOutResult) {
        soundService.click();
        gameService.resetResults();
        return;
      }

      if (isGamePadDisabled || connectionError || reconnect) return;

      document.body.click();
      soundService.click();
      event.preventDefault();

      handleStart();
    },
    [reconnect, betResult, resultReportState, doSpinState, connectionError, cashOutResult, setIsGamePadDisabled, isGamePadDisabled]);


  const handleStart = useCallback(() => {

    if(isGamePadDisabled) return

    if (resultReportState || doSpinState) {
      return handleFieldClick(getRandomField(matrixType), betResult.step);
    }
    soundService.click();
    setIsGamePadDisabled(true);
    gameLiveConnection.sendDoSpin();

  }, [gameStore, matrixType, resultReportState, doSpinState, betResult,isGamePadDisabled]);

  return {
    handleBetAmount,
    handleFieldClick,
    handleMatrixChange,
    handleStart,
    handleCashOutButton,
    handleSpaceSpin,
  };
};